const PRODUCTION_ENV = 'production';

export abstract class ConfigurationService {
  static getApi(): string {
    return globalThis.DELMONICOS_ENV.DELMONICOS_API;
  }

  static getGoogleApiKey(): string {
    return globalThis.DELMONICOS_ENV.DELMONICOS_GOOGLE_API_KEY;
  }

  static getLogLevel(): string {
    return globalThis.DELMONICOS_ENV.DELMONICOS_LOG_LEVEL;
  }

  static isProduction(): boolean {
    return process.env.NODE_ENV === PRODUCTION_ENV;
  }

  static getVersion(): string {
    return process.env.VERSION ?? '';
  }

  static toJSON(): Record<string, string> {
    return {
      isProduction: this.isProduction().toString(),
      api: this.getApi(),
      version: this.getVersion(),
      logLevel: this.getLogLevel(),
    };
  }
}
